import * as React from 'react';

import type { OpenAIMessageModalInput } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/types';

/**
 * Imperative surface exposed by {@link AIMessageModalProvider} via
 * {@link useAIMessageModal}. Kept tiny — consumers only get to open or
 * close the modal; the draft state lives inside the modal itself.
 */
export type AIMessageModalApi = {
  openModal: (input?: OpenAIMessageModalInput) => void;
  closeModal: () => void;
};

export const AIMessageModalContext = React.createContext<AIMessageModalApi | null>(null);
